import { render, staticRenderFns } from "./TikTokIcon.vue?vue&type=template&id=1f15441e&"
import script from "./TikTokIcon.vue?vue&type=script&lang=js&"
export * from "./TikTokIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports